import styled from "@emotion/styled";
import React from "react";
import { CustomThemeType } from "../../context/Providers";

const IconButtonWrapper = styled.button<{ theme?: CustomThemeType }>`
  border-radius: 50%;
  background-color: transparent;
  transition: background-color 0.5s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: transparent;
  }
`;

interface IconButtonProps {
  children: any;
  onClick: (e: any) => any;
  size?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  children,
  onClick,
  size = "auto",
}) => {
  return (
    <IconButtonWrapper
      onClick={(e) => onClick(e)}
      style={{ width: size, height: size }}
    >
      {children}
    </IconButtonWrapper>
  );
};

export default IconButton;
